<template>
  <AppDialog 
    v-model:is-open="isDialogOpened"
    data-locator="ai-assistant-help-center-modal"
    size="xl"
    @cancel="closeDialog"
  >
    <template #title>
      <div class="ai-assistant-modal__title my-6">{{ $t(`${TRANSLATION_KEY_PREFIX}.title`) }}</div>
    </template>
    <template #body>
      <div class="ai-assistant-modal__body d-flex flex-column row-gap-6 px-4">
        <template v-for="link in links" :key="link.name">
          <div class="link-group d-flex align-center" :data-locator="`${link.dataLocator}-link-group`">
            <div class="link-group__content">
              <p class="font-weight-bold">{{ $t(`${TRANSLATION_KEY_PREFIX}.list.${link.name}.title`) }}</p>
              <p>{{ $t(`${TRANSLATION_KEY_PREFIX}.list.${link.name}.description`) }}</p>
            </div>
            <app-button class="ml-auto" :data-locator="`${link.dataLocator}-link-button`" @click="link.action">
              {{ $t(`${TRANSLATION_KEY_PREFIX}.list.${link.name}.buttonLabel`) }}
            </app-button>
          </div>
        </template>
      </div>
    </template>
    <template #footer></template>
  </AppDialog>
</template>

<script lang="ts">
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantHelpCenterModal'

export default {
  name: 'AIAssistantHelpCenterModal',
  components: { AppDialog },
  mixins: [dialogMixin],
  data() {
    return {
      TRANSLATION_KEY_PREFIX,
    }
  },
  computed: {
    links () {
      return [
        {
          action: false,
          dataLocator: 'start-tour',
          name: 'startTour',

        },
        {
          action: false,
          dataLocator: 'learn-more',
          name: 'learnMore',
        },
        {
          action: () => this.openFAQ(),
          dataLocator: 'faq',
          name: 'faq',
        },
      ]
    },
  },
  methods: {
    openFAQ() {
      const faqUrl = this.$i18n.locale === 'fr' ? 'https://help.closd.com/fr/' : 'https://help.closd.com/en/'
      window.open(faqUrl, '_blank')
    },
  },
}
</script>

<style scoped lang="scss">
.ai-assistant-modal__title, .ai-assistant-modal__body {
  font-family: 'Lato', sans-serif;
}
.ai-assistant-modal__title {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}
.ai-assistant-modal__body {
  font-size: 16px;

  .link-group__content {
    max-width: 375px;
  }

  .app-button {
    font-weight: bold;
    font-size: 16px;

    &:not(:disabled), &:focus {    
      background-color: rgb(var(--v-theme-purple-darken-1));
      color: white !important;

      &:hover, &:active {
        background-color: rgb(var(--v-theme-purple-darken-4)) !important;
      }
    }
  }
}
</style>